import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Institucion, InstitucionResponse } from '../models/institucion.interface';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';
import { firstValueFrom } from 'rxjs';
import { BackendAuthService } from './backend-auth.service';
import { SessionService } from './session.service';

@Injectable({
  providedIn: 'root'
})
export class InstitucionService {

  constructor(private http: HttpClient, private authService: BackendAuthService, private sessionService: SessionService) { }

  async buscarPorRut(rut: number): Promise<Institucion> {
    const tokenRes = await this.authService.obtenerToken();
    const token = tokenRes.access_token;
    const url = environment.backendUrl + '/esi-instituciones?rut=' + rut;
    const http = this.http.post<InstitucionResponse>(url, {}, {
      headers: {
        'Authorization': 'Bearer ' + token,
        'session_id': this.sessionService.getToken() || ''
      }
    });
    return firstValueFrom(http).then((response) => response.data[0] as Institucion);
  }
}
